import { ViewModelResultadoEnvio } from './../shared/models/viewModelResultadoEnvio';
import { BaixaCobrancaService } from './../shared/services/baixaCobranca.service';
import { RegistroCobrancaService } from './../shared/services/registroCobranca.service';
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MatSnackBar } from '@angular/material';
import { ViewModelEnviaCobranca } from '../shared/models/enviaCobranca.model';
import { WebCliente } from "../shared/models/webCliente.model";
import { WebClienteService } from '../shared/services/webCliente.service';

@Component({
    selector: 'app-integracaobancaria',
    templateUrl: './integracaobancaria.component.html',
    styleUrls: ['./integracaobancaria.component.scss']
})

export default class IntegracaoBancariaComponent implements OnInit {

    dataFormatada: string;

    dataVencimento: Date;
    viewModelEnviaCobranca: ViewModelEnviaCobranca = new ViewModelEnviaCobranca();
    viewModelResultadoEnvio: ViewModelResultadoEnvio = new ViewModelResultadoEnvio();
    webCliente: WebCliente = new WebCliente();
    loading = false;
    today: Date = new Date();
    currentYear: number = this.today.getFullYear();
    currentMonth: number = this.today.getMonth();
    currentDay: number = this.today.getDate();
    minDate: Object = new Date(
        this.currentYear,
        this.currentMonth,
        this.currentDay
    );
    resultado: boolean = false;

    constructor(
        private readonly router: Router,
        private _snackBar: MatSnackBar,
        private readonly registroCobrancaService: RegistroCobrancaService,
        private readonly baixaCobrancaService: BaixaCobrancaService,
        private webClienteService: WebClienteService
    ) {



    }

    ngOnInit() {
        this.webClienteService.getById(1).subscribe(cliente => { this.webCliente = cliente; });
        console.log(this.webCliente);
    }

    enviaCobranca() {
        this.loading = true;
        this.viewModelEnviaCobranca.dataVencimento = this.dataVencimento;

        if (this.viewModelEnviaCobranca.dataVencimento === undefined) {
            this.loading = false;
            this._snackBar.open('Preencha uma data de vencimento. ', 'X', {
                duration: 6000,
                panelClass: ['green-snackbar']

            });
        } else {
            this.registroCobrancaService.Post(this.viewModelEnviaCobranca).subscribe(retorno => {
                this.loading = false;
                this.resultadoCobranca();
                this._snackBar.open('A solicitação foi realizada com sucesso. ', 'X', {
                    duration: 6000,
                    panelClass: ['green-snackbar']

                })


            }, error => {
                this.loading = false;
                this._snackBar.open(error.error, 'X', {
                    duration: 8000,
                    panelClass: ['red-snackbar']
                })
            });

        }
    }

    resultadoCobranca() {
        this.formataDataAtual();
        this.registroCobrancaService.getResultadoEnvio(this.dataFormatada).subscribe(retorno => {
            if (retorno) {
                this.viewModelResultadoEnvio = retorno;
                this.resultado = true;
            }
        }, error => {
            this.loading = false;
            this._snackBar.open('Error ao trazer os Dados dos boletos', 'X', {
                duration: 8000,
                panelClass: ['red-snackbar']
            })
        });

    }
    baixaCobranca() {
        this.loading = true;
        this.baixaCobrancaService.Post().subscribe(retorno => {
            this.loading = false;
            this._snackBar.open('A solicitação foi realizada com sucesso.', 'X', {
                duration: 6000,
                panelClass: ['green-snackbar']

            })


        }, error => {
            this.loading = false;
            this._snackBar.open('Erro ao realizar a solicitação.', 'X', {
                duration: 8000,
                panelClass: ['red-snackbar']
            })
        });
    }
    formataDataAtual() {
        var dia = this.dataVencimento.getDate();
        var mes = this.dataVencimento.getMonth() + 1;
        var ano = this.dataVencimento.getFullYear();
        this.dataFormatada = ano + "-" + (mes < 10 ? ('0' + mes) : mes) + "-" + (dia < 10 ? ('0' + dia) : dia);

    }

}